import React, { Component } from 'react'

import { Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import { Crumbs, Crumb } from 'components/BreadCrumbs'
import HeadingBanner from 'components/Text/HeadingBanner'
import Button from 'components/Button'
import BillingAccountForm from 'features/Billing/BillingAccountForm'

import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sAnim from 'components/Animation/Animation.scss'

export default class BillingAccount extends Component {
  componentWillMount() {
    const { getBillingAccount, ban } = this.props
    getBillingAccount(ban)
  }

  render() {
    const { billingAccount, billingAccounts, ban, savePending, submit } = this.props

    const absChildren = (
      <Button
        color="tertiary"
        className={sAnim.fromBottom}
        stickyBottom
        loading={savePending}
        disabled={savePending}
        onClick={() => submit('billingAccountForm')}
      >
        Update
      </Button>
    )

    return (
      <Page layout={{ header: 'app' }} title="Billing" absChildren={absChildren}>
        <PageHeader>
          <Crumbs title="Billing">
            <Crumb to="/dashboard/billing">Bills</Crumb>
            <Crumb to="/dashboard/billing/payments">Payments</Crumb>
            {billingAccounts.length > 1 && (
              <Crumb parent to="/dashboard/billing/accounts">
                Accounts
              </Crumb>
            )}
            <Crumb active to={`/dashboard/billing/accounts/${ban}`}>
              {billingAccount.customer}
            </Crumb>
          </Crumbs>
          <HeadingBanner>
            <h3 className={cn(sText.heading3, sText.accent)}>We love it when you update us.</h3>
            <div className={sText.descrip2}>
              To update your Billing Account complete the below fields, and we'll take care of the
              rest.
            </div>
          </HeadingBanner>
        </PageHeader>
        <Container paddingTop paddingBottom className="sm">
          <BillingAccountForm billingAccount={billingAccount} />
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/BillingAccount/BillingAccount.jsx